export enum ApprovalActions {
  APPROVE = 'Approve',
  REJECT = 'Reject',
}
